/** Shared, tileable angular aeration planes. Generated once; no frame work or
 * extra geometry. Irregular cells avoid a repeated checkerboard/scallop grid. */
import * as THREE from 'three';
let texture:THREE.DataTexture|undefined;
export function waterfallFacetTexture():THREE.DataTexture {
 if(texture)return texture;
 const size=256,cells=16,data=new Uint8Array(size*size*4),seeds: {x:number;y:number;tone:number;cx:number;cy:number}[]=[];
 let state=0x49bcea13;
 const random=()=>{state=(Math.imul(state,1664525)+1013904223)|0;return(state>>>0)/4294967296;};
 for(let y=0;y<cells;y++)for(let x=0;x<cells;x++){
  const dx=.12+.76*random(),dy=.12+.76*random(),tone=.16+.72*random(),cut=random()*Math.PI*2;
  seeds.push({x:dx,y:dy,tone,cx:Math.cos(cut),cy:Math.sin(cut)});
 }
 for(let y=0;y<size;y++)for(let x=0;x<size;x++){
  const px=(x+.5)*cells/size,py=(y+.5)*cells/size,ix=Math.floor(px),iy=Math.floor(py);
  let first=Infinity,second=Infinity,tone=0;
  for(let j=-1;j<=1;j++)for(let i=-1;i<=1;i++){
   const sx=ix+i,sy=iy+j,seed=seeds[((sy+cells)%cells)*cells+(sx+cells)%cells];
   const dx=px-sx-seed.x,dy=py-sy-seed.y,d=dx*dx+dy*dy;
   if(d<first){second=first;first=d;tone=seed.tone+(dx*seed.cx+dy*seed.cy>0?.07:-.07);}
   else if(d<second)second=d;
  }
  const at=(y*size+x)*4;
  data[at]=Math.round(Math.max(0,Math.min(1,tone))*255);
  data[at+1]=Math.round(Math.min(1,(Math.sqrt(second)-Math.sqrt(first))*3)*255);
  data[at+2]=255;data[at+3]=255;
 }
 texture=new THREE.DataTexture(data,size,size);texture.wrapS=texture.wrapT=THREE.RepeatWrapping;
 texture.minFilter=THREE.LinearMipmapLinearFilter;texture.magFilter=THREE.LinearFilter;
 texture.generateMipmaps=true;texture.needsUpdate=true;texture.name='waterfall angular aeration';return texture;
}
